import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_typography.scss'

import { Props, SizeNS, SpanAttributes } from '../utils/types'

export namespace FontStyleNS {
  export const italic = 'italic'
  export const none = ''
}

export namespace FontVariantNS {
  export const primary = 'primary'
  export const secondary = 'secondary'
  export const tertiary = 'tertiary'
  export const tableHeader = 'tableHeader'
  export const white = 'white'
  export const blue = 'blue'
  export const red = 'red'
}

export namespace FontWeightNS {
  export const regular = 'regular'
  export const medium = 'medium'
  export const bold = 'bold'
}

export type FontSize =
  | typeof SizeNS.xs
  | typeof SizeNS.sm
  | typeof SizeNS.md
  | typeof SizeNS.lg

export type FontStyle = typeof FontStyleNS.italic | typeof FontStyleNS.none

type FontVariant =
  | typeof FontVariantNS.primary
  | typeof FontVariantNS.secondary
  | typeof FontVariantNS.tertiary
  | typeof FontVariantNS.tableHeader
  | typeof FontVariantNS.white
  | typeof FontVariantNS.blue
  | typeof FontVariantNS.red

type FontWeight =
  | typeof FontWeightNS.regular
  | typeof FontWeightNS.medium
  | typeof FontWeightNS.bold

interface FontProps extends Props {
  fontStyle?: FontStyle
  size?: FontSize
  variant?: FontVariant
  weight?: FontWeight
}

const cx = bind(styles)

const availableFonts = Object.keys(styles)

export const Font = React.forwardRef<
  HTMLSpanElement,
  SpanAttributes & FontProps
>(
  (
    {
      children,
      className,
      size = SizeNS.sm,
      weight = FontWeightNS.regular,
      fontStyle = FontStyleNS.none,
      variant = FontVariantNS.primary,
      ...props
    },
    ref
  ) => {
    const style = fontStyle ? `-${fontStyle}` : ''
    const fontClassName = `core-${size}-${weight}${style}--${variant}`

    if (availableFonts.indexOf(fontClassName) < 0) {
      console.error(
        `Warning: Font component failed to load class; ${fontClassName} does not exist.`
      )
    }

    return (
      <span ref={ref} className={cx(fontClassName, className)} {...props}>
        {children}
      </span>
    )
  }
)

Font.displayName = 'Font'

export default Font
